import { useState } from "react";
import type { PoolInfo } from "../types/pool";
import "./LivePoolDashboard.css";

interface LivePoolDashboardProps {
  pool: PoolInfo;
  onDone: () => void;
}

export function LivePoolDashboard({ pool, onDone }: LivePoolDashboardProps) {
  const [swapIn, setSwapIn] = useState("");
  const [swapOut, setSwapOut] = useState("~0.05");
  const [exactIn, setExactIn] = useState(true);
  const tvl = 2000;
  const centeredness = 85;
  const virtualA = 1000;
  const virtualB = 0.5;
  const alertOk = true;

  return (
    <div className="live-pool-dashboard screen">
      <header className="dashboard-header compact">
        <h1>Live Pool</h1>
        <button type="button" className="done-btn" onClick={onDone}>
          Done · Back to Pools
        </button>
      </header>

      <div className="live-pool-stats">
        <div className="stat-card">
          <span className="stat-label">Pool</span>
          <span className="stat-value">
            {pool.tokenA}/{pool.tokenB}
          </span>
        </div>
        <div className="stat-card">
          <span className="stat-label">TVL</span>
          <span className="stat-value">${tvl.toLocaleString()}</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Centeredness</span>
          <span className="stat-value">{centeredness}%</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Glide</span>
          <span className="stat-value">Active</span>
        </div>
      </div>

      <div className="virtual-balances">
        <span className="label">Virtual Balances (ReClamm)</span>
        <span>
          V_A {virtualA} / V_B {virtualB}
        </span>
      </div>

      <section className="swap-section">
        <h2>Swap</h2>
        <div className="swap-row">
          <input
            type="text"
            placeholder="Input amount"
            value={swapIn}
            onChange={(e) => setSwapIn(e.target.value)}
          />
          <span className="swap-token">{pool.tokenA}</span>
        </div>
        <div className="swap-arrow">↓</div>
        <div className="swap-row">
          <input
            type="text"
            readOnly
            value={swapOut}
            className="swap-output"
          />
          <span className="swap-token">{pool.tokenB}</span>
        </div>
        <div className="swap-mode">
          <label>
            <input
              type="radio"
              checked={exactIn}
              onChange={() => setExactIn(true)}
            />
            exact_in
          </label>
          <label>
            <input
              type="radio"
              checked={!exactIn}
              onChange={() => setExactIn(false)}
            />
            exact_out
          </label>
        </div>
        <button type="button" className="swap-btn">
          Swap
        </button>
      </section>

      <section className="queries-section">
        <h2>Queries</h2>
        <div className="query-buttons">
          <button type="button">Get Pool Info</button>
          <button type="button">Get Centered State</button>
          <button type="button">Get Virtual State</button>
          <button type="button">Refresh Stats</button>
        </div>
      </section>

      <div className={`alerts ${alertOk ? "ok" : "warn"}`}>
        {alertOk ? "All good! (Green)" : "Pool Paused – Check Governance"}
      </div>
    </div>
  );
}
